import { Tooltip } from 'antd';
import { Box } from '@mui/material';
// import screenIcon from "../../assets/images/icons/screenIcon.svg";
import ScreenIcon from 'assets/icons/screen';

// export const ScreenIcon = ({ width, color = '#000' }) => {
// 	return (
// 		<svg xmlns="http://www.w3.org/2000/svg" width={width} height={width} viewBox="0 0 15 15">
// 			<path fill="none" stroke={color} d="M4 14.5h7M.5 2.5v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-12a1 1 0 0 0-1 1Z" />
// 		</svg>
// 	);
// };

const ScreenMenu = ({ screenSize, setScreenSize, iconColor = '#fff', activeBorderColor = '#fff' }) => {
	return (
		<Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
			<Tooltip title="Small Screen">
				<Box
					onClick={() => setScreenSize('md')}
					sx={{
						// padding: "4px",
						// paddingBottom: "6px",
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						transition: 'all 0.3s',
						borderBottom: `1px solid ${screenSize === 'md' ? activeBorderColor : 'transparent'}`,

						'&:hover': {
							transform: 'scale(1.25)',
						},
					}}
				>
					<ScreenIcon width="9px" height="9px" color={iconColor} />
				</Box>
			</Tooltip>

			<Tooltip title="Large Screen">
				<Box
					onClick={() => setScreenSize('lg')}
					sx={{
						// padding: "4px",
						// paddingBottom: "6px",
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						transition: 'all 0.3s',
						borderBottom: `1px solid ${screenSize === 'lg' ? activeBorderColor : 'transparent'}`,

						'&:hover': {
							transform: 'scale(1.2)',
						},
					}}
				>
					<ScreenIcon width="12px" height="12px" color={iconColor} />
				</Box>
			</Tooltip>

			<Tooltip title="Full Screen">
				<Box
					onClick={() => setScreenSize('full')}
					sx={{
						// padding: "4px",
						// paddingBottom: "6px",
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						transition: 'all 0.3s',
						borderBottom: `1px solid ${screenSize === 'full' ? activeBorderColor : 'transparent'}`,

						'&:hover': {
							transform: 'scale(1.2)',
						},
					}}
				>
					<ScreenIcon width="15px" height="15px" color={iconColor} />
				</Box>
			</Tooltip>
		</Box>
	);
};

export default ScreenMenu;
